module.exports = __webpack_public_path__ + "static/img/3.3fe42ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.jpg
// module id = iCB0
// module chunks = 26